declare const ENV_VARS_AS_JSON: string | undefined;

const resolveEnvVars = (): Record<string, unknown> => {
  try {
    if (typeof ENV_VARS_AS_JSON !== "undefined" && ENV_VARS_AS_JSON) {
      return JSON.parse(ENV_VARS_AS_JSON);
    }

    console.error("ENV_VARS_AS_JSON is not defined", {
      ENV_VARS_AS_JSON:
        typeof ENV_VARS_AS_JSON !== "undefined" ? ENV_VARS_AS_JSON : undefined,
    });
  } catch (error) {
    console.error("Failed to parse ENV_VARS_AS_JSON", error);
  }

  return {};
};

const ENV_VARS = resolveEnvVars();

export const GetEnvVars = <T extends object>() => ENV_VARS as T;
